import { render, staticRenderFns } from "./VacanciesIndicators.vue?vue&type=template&id=6b12affa&scoped=true"
import script from "./VacanciesIndicators.vue?vue&type=script&lang=js"
export * from "./VacanciesIndicators.vue?vue&type=script&lang=js"
import style0 from "./VacanciesIndicators.vue?vue&type=style&index=0&id=6b12affa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b12affa",
  null
  
)

export default component.exports